<template>
  <div
    class="news-item"
    @click="() => handleClick()"
  >
    <div class="left">
      <img
        class="thumbnail"
        :src="data.file_path"
      />
    </div>
    <div class="right">
      <div class="headline">
        {{data.article_title}}
      </div>
      <div class="description">
        {{data.dec}}
      </div>
      <div class="footer">
        <div class="label">
          <span>最新动态</span>
        </div>
        <div class="time">
          {{data.release_time}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["click"],
  computed: {
  },
  data(){
    return {
    };
  },
  methods: {
    handleClick(){
      this.$emit("click", this.data);
    }
  }
};
</script>

<style lang="less" scoped>
.news-item {
  flex: 1;
  padding: 10px;
  margin: 0 8px 14px;
  min-width: 584px;
  max-width: 584px;
  box-shadow: 0 6px 7px 0 rgba(47, 114, 245, .1);
  border-radius: 10px;
  height: 180px;
  display: flex;
  .left, .right {
    margin-top: 15px;
    flex: 1;
  }
  .left {
    max-width: 169.19px;
    .thumbnail {
      cursor: pointer;
      width: 169.19px;
      height: 103.45px;
    }
  }
  .right {
    max-width: 375px;
    margin-left: 10px;
    .headline {
      cursor: pointer;
      font-size: 18px;
      font-weight: normal;
      color: #333333;
      line-height: 34px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .description {
      min-height: 70px;
      font-size: 14px;
      color: #666666;
      line-height: 31px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .footer {
      display: flex;
      line-height: 34px;
      align-items: end;
      .label > span {
        border: 1px solid #00349a;
        border-radius: 10px;
        color: #00349a;
        padding: 2px 7px;
      }
      .label, .forum {
        margin-right: 10px;
      }
    }
  }
}
</style>